class window.News
  constructor: ->
    @newsList = $('.grid-news-list')
    @news = $('.js-news-date-range')
    @clearButton = $('.clear-news-filter-js')
    @hoverFlag = true
    @startDate = null
    @endDate = null
    @rubric = null
    @territory = null
    @newsCategoryFilterInit()
    @newsRubricsFilterInit()
    @initHoverToNewsBlocks()
    @dateInputInit()
    @selectTerritoryInit()
    @clearButtonInit()



# Инициализация затенения контента при наведение на боковой блок с новостями
  initHoverToNewsBlocks: ->
    self = this
#    @newsList.hover ->
#      if self.hoverFlag
#        self.hoverFlag = false
#        window.shadingContent = [this, 'header, .gosbar']
#        window.shading.shadingActive(window.shadingContent)
#
#    @newsList.mouseleave ->
#      unless self.hoverFlag
#        self.hoverFlag = true
#        window.shadingContent = [this, 'header, .gosbar']
#        window.shading.shadingDisable(window.shadingContent)

  dateInputInit: ->
    self = this

    if $(window).width() <= 720
      numberOfMonth = 1
    else
      numberOfMonth = 2

    $('.js-news-date-range').each ->
      if $(this).attr('data-init') != false
        $(this).attr('data-init', true)

        datepickerContainer = $(this).parent('.base-date-picker')
        $(this).dateRangePicker({
          container: $(datepickerContainer)
          autoClose: true
          format: 'DD.MM.YYYY'
          separator: '-'
          startOfWeek: 'monday'
        })
        .bind('datepicker-change',
          (event, obj)->
            dates = obj.value.split('-')
            self.startDate = dates[0]
            self.endDate = dates[1]
            self.changeDateInput(self.startDate, self.endDate)
        )

  dateInputUpdate: ->
    self = this
    self.startDate = null
    self.endDate = null
    $('.js-news-date-range').data('dateRangePicker').clear()


  clearButtonInit: () ->
    self = this
    @clearButton.click (event)->
      self.startDate = null
      self.endDate = null
      self.territory = null
      self.rubric = null

      self.dateInputUpdate()
      self.selectTerritoryUpdate()
      window.ajaxLoadNews.init()
      self.clearButtonHide()


  clearButtonHide: ->
    if @clearButton.hasClass('active')
      @clearButton.removeClass('active')


  clearButtonShow: ->
    if !@clearButton.hasClass('active')
      @clearButton.addClass('active')



  changeDateInput: (startDate, endDate)->
    self = this
    window.ajaxLoadNews.init(startDate, endDate, self.territory, self.rubric)
    @clearButtonShow()

  selectTerritoryInit: ->
    self = this
    selectWrapper = $('.news-filter__select-territory').parent('.base-input-wrapper')
    $('.news-filter__select-territory').each ->
      $(this).selectmenu({
        appendTo: selectWrapper
        classes: {
          "ui-selectmenu-menu": "highlight"
        }
        select: (event, ui) ->
          self.territory = ui.item.value

          window.ajaxLoadNews.init(self.startDate, self.endDate, self.territory, self.rubric)
          self.clearButtonShow()
      })

  selectTerritoryUpdate: ->
    self = this
    self.territory = null
    $('.news-filter__select-territory').val('')
    $('.news-filter__select-territory').selectmenu("refresh")

  newsCategoryFilterInit: ->
    filterCategories = $('.news-category-tabs .page-switch__option-button')
    if filterCategories.length > 6
      if $(window).width() >= 425 && $(window).width() <= 768
        this.newsCategoryFilterRender(4,filterCategories)
      else if $(window).width() >= 768 && $(window).width() <= 1024
        this.newsCategoryFilterRender(6,filterCategories)
      else if filterCategories.length > 7
        this.newsCategoryFilterRender(7,filterCategories)

  newsCategoryFilterRender: (countItems, filterCategories) ->
    self = this
    arrowHtml = '<div class="select-arrow">' +
      '<div class="base-icon-block">' +
      '...' +  '</div></div>'
    $('.news-rubrics-tabs .page-switch').append('<div class="base-input-wrapper base-select--middle"><select class="js-additional-category additional-category"><option value="">Все рубрики</option></select></div>')
    for index in [countItems..filterCategories.length - 1]
      href = $(filterCategories[index]).attr('href')
      sectionId = $(filterCategories[index]).attr('data-section-id')
      text = $(filterCategories[index]).find('.page-switch__option-text').text()
      if (text == '')
        text = $(filterCategories[index]).text()

      $(filterCategories[index]).remove()
      if text != ''
        elementHtml = '<option value="' + sectionId + '" data-section-id="' + sectionId + '">' + text + '</option>'
        $('.js-additional-category').append(elementHtml)

    $('.js-additional-category').selectmenu({
      appendTo: $('.news-rubrics-tabs .page-switch .base-select--middle')
      classes: {
        "ui-selectmenu-menu": "highlight"
      }
      select: (event, ui) ->
        if ui.item.value != ''
          self.rubric =  ui.item.value
          window.ajaxLoadNews.init(self.startDate, self.endDate, self.territory, self.rubric)
          self.clearButtonShow()
          # window.location.href = ui.item.value
  #          self.clearButtonShow()

      open: () ->
        shadingContent = [this, 'header', '.news-filter__wrapper']
#        unless self.popupPageOpen
  #        self.menuLink.addClass('header-menu__link--disable')
  #        $(this).removeClass('header-menu__link--disable')
        window.shading.shadingActive(shadingContent)

      close: () ->
        shadingContent = [this, 'header', '.news-filter__wrapper']
#        unless self.popupPageOpen && self.notificationOpen == false
#        self.menuLink.removeClass('header-menu__link--disable')
        window.shading.shadingDisable(shadingContent)
    })

    $('.page-switch .ui-selectmenu-button').append(arrowHtml)

  newsRubricsFilterInit: ->
    self = this
    filterRubrics = $('.news-rubrics-tabs .page-switch .news-rubric-link')

    if filterRubrics.length > 6
      if $(window).width() >= 425 && $(window).width() <= 768
        this.newsCategoryFilterRender(4,filterRubrics)
      else if $(window).width() >= 768 && $(window).width() <= 1024
        this.newsCategoryFilterRender(6,filterRubrics)
      else if filterRubrics.length > 7
        this.newsCategoryFilterRender(7,filterRubrics)

    $(filterRubrics).each ->
      $(this).click (event) ->
        $(filterRubrics).removeClass('active')
        $(this).addClass('active')
        event.preventDefault()
        self.rubric = $(this).attr('data-section-id')
        self.clearButtonShow()

        window.ajaxLoadNews.init(self.startDate, self.endDate, self.territory, self.rubric)


// WEBPACK FOOTER //
// ./assets/javascripts/app/news.coffee